import { Box, InputBase, Typography } from '@mui/material'
import { ChangeEvent, FC } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useTranslation } from 'react-i18next'
import CustomInput from './CustomInput'

interface PaymentFormProps {
  selectedDate: Date | null
  dollars: string
  cents: string
  onAgreeToTermsChange: (event: ChangeEvent<HTMLInputElement>) => void
  onDollarsChange: (value: string) => void
  onCentsChange: (value: string) => void
  onDateChange: (date: Date | null) => void
}

const PaymentForm: FC<PaymentFormProps> = ({
  selectedDate,
  dollars,
  cents,
  onDateChange,
  onDollarsChange,
  onCentsChange,
}) => {
  const { t } = useTranslation()
  const today = new Date();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          maxWidth: '320px',
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: '200' }} component="h3">
            {t('payment.paymentDate')}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={selectedDate}
              onChange={onDateChange}
              format="dd/MM/yyyy"
              minDate={today}
              slots={{ textField: () => <CustomInput value={selectedDate ? selectedDate.toString() : ''} onClick={() => {}} /> }}
            />
          </LocalizationProvider>
        </Box>

        <Typography sx={{ fontWeight: '200' }} variant="h6" component="h2">
          {t('payment.sum')}
        </Typography>

        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0.25rem',
              alignItems: 'baseline',
            }}
          >
            <InputBase
              value={dollars}
              onChange={(e) => onDollarsChange(e.target.value)}
              placeholder="0"
              sx={{
                fontSize: '5rem',
                fontWeight: '200',
                color: 'white',
                '& .MuiInputBase-input': {
                  textAlign: 'right',
                  pr: '0.25rem',
                  minWidth: '180px',
                  color: 'white',
                  '&::placeholder': {
                    color: 'white',
                    opacity: 1,
                  },
                },
              }}
              inputProps={{ maxLength: 7 }}
            />
            <Typography
              variant="h2"
              component="span"
              sx={{
                lineHeight: '4rem',
                fontSize: '4rem',
                verticalAlign: 'bottom',
              }}
            >
              .
            </Typography>
            <InputBase
              value={cents}
              onChange={(e) => onCentsChange(e.target.value)}
              placeholder="00"
              sx={{
                fontSize: '5rem',
                fontWeight: '200',
                color: 'grey',
                '& .MuiInputBase-input': {
                  textAlign: 'left',
                  pl: '0.25rem',
                  minWidth: '100px',
                  '&::placeholder': {
                    opacity: 1,
                  },
                },
              }}
              inputProps={{ maxLength: 2 }}
            />
            <Typography
              sx={{
                fontSize: '4.6rem',
                fontWeight: '200',
                color: 'grey',
              }}
              variant="h2"
            >
              $
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default PaymentForm
